import { Button } from '@mui/material';
import { DataCellProps } from '../types';
import { FC } from 'react';
import { ImpersonateLoadingButton } from 'TeamModule/components/ImpersonateAccountMenu/ImpersonateLoadingButton';
import { MemberRoles } from 'TeamModule/constants/member';
import { useGrowthBookFlag } from 'hooks/useGrowthBookFlag';

export const TeamMemberImpersonateCell: FC<DataCellProps> = ({
  onImpersonate,
  member,
  isLoadingImpersonation,
}) => {
  const { isOn: isSignInStatusOn } = useGrowthBookFlag('memberManagementTableV2Flag');
  // GLX-2015: a member whose sign-in is off can't be impersonated, like No Access today
  const isInactive = isSignInStatusOn && member?.login_enabled === false;
  const { buttonLabel, impersonationDisabled } = member?.is_archived
    ? {
        impersonationDisabled: true,
        buttonLabel: 'Member archived',
      }
    : member?.role_name === MemberRoles.NoAccess
      ? {
          impersonationDisabled: true,
          buttonLabel: 'No access to the Mosaic team',
        }
      : isInactive
        ? {
            impersonationDisabled: true,
            buttonLabel: 'Sign-in turned off',
          }
        : {
            buttonLabel: 'Impersonate',
            impersonationDisabled: false,
          };

  const handleImpersonateClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onImpersonate(event);
  };

  // GLX-2075: rows render before the team's tags are known; the states above
  // need no tags, so they still win over the loading button.
  if (!impersonationDisabled && isLoadingImpersonation) {
    return <ImpersonateLoadingButton />;
  }

  return (
    <Button
      color="primary"
      variant="outlined"
      onClick={impersonationDisabled ? undefined : handleImpersonateClick}
      disabled={impersonationDisabled}
    >
      {buttonLabel}
    </Button>
  );
};
